<template>
  <v-container>
    <v-layout column text-center wrap align-content-center justify-center>
      <v-card width="640">
        <v-toolbar color="primary" dark flat>
          <v-toolbar-title>
            {{ formModel == 0 ? "Log In" : "Reset Password" }}
          </v-toolbar-title>
        </v-toolbar>
        <v-card-text class="pt-4">
          <v-layout wrap style="max-width: 600px">
            <v-flex xs12>
              <v-alert v-if="error" border="bottom" colored-border type="error">
                {{ error }}
              </v-alert>
            </v-flex>
            <v-tabs-items
              v-model="formModel"
              class="flex xs12"
              :touchless="true"
            >
              <v-tab-item>
                <v-form
                  v-model="valid"
                  ref="form"
                  lazy-validation
                  class="flex-grow-1"
                  autocomplete="on"
                >
                  <v-text-field
                    type="email"
                    label="Email"
                    v-model="email"
                    :rules="emailRules"
                    required
                    filled
                  ></v-text-field>
                  <v-text-field
                    label="Password"
                    v-model="password"
                    min="8"
                    :append-icon="
                      showPassword ? 'visibility' : 'visibility_off'
                    "
                    @click:append="showPassword = !showPassword"
                    :type="showPassword ? 'text' : 'password'"
                    :rules="passwordRules"
                    counter
                    required
                    filled
                  ></v-text-field>
                  <v-layout justify-space-between>
                    <a @click="formModel = 1">Forgot Password?</a>
                    <v-spacer></v-spacer>
                    <v-btn
                      type="submit"
                      @click.prevent="submit"
                      :disabled="!valid"
                      color="secondary"
                    >
                      Log in
                    </v-btn>
                  </v-layout>
                </v-form>
              </v-tab-item>
              <v-tab-item>
                <span v-if="hasResetPassword">
                  An email has been sent to {{ email }} with instructions on how
                  to reset your password. Feel free to close this tab now
                </span>
                <v-form
                  v-model="resetPasswordValid"
                  ref="resetPasswordForm"
                  lazy-validation
                  class="flex-grow-1"
                  autocomplete="on"
                  v-else
                >
                  <v-text-field
                    label="Email"
                    v-model="email"
                    :rules="emailRules"
                    required
                    filled
                  ></v-text-field>
                  <v-layout justify-space-between>
                    <v-btn text color="error" @click="formModel = 0">
                      Cancel
                    </v-btn>
                    <v-spacer></v-spacer>
                    <v-btn
                      type="submit"
                      @click.prevent="resetPassword"
                      :disabled="!resetPasswordValid"
                      color="secondary"
                    >
                      Reset password
                    </v-btn>
                  </v-layout>
                </v-form>
              </v-tab-item>
            </v-tabs-items>
          </v-layout>
        </v-card-text>
        <v-progress-linear
          indeterminate
          :active="showLoading"
        ></v-progress-linear>
      </v-card>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  data() {
    return {
      valid: false,
      resetPasswordValid: false,
      showPassword: false,
      hasResetPassword: false,
      password: "",
      passwordRules: [(v) => !!v || "Password is required"],
      email: "",
      emailRules: [(v) => !!v || "E-mail is required"],
      error: "",
      showLoading: false,
      formModel: 0,
    };
  },
  methods: {
    submit() {
      if (this.$refs.form.validate()) {
        this.showLoading = true;
        this.$store.state.axios
          .post("api/auth/login", {
            email: this.email,
            password: this.password,
          })
          .then((res) => {
            this.$store.commit("setUser", res.data);
            this.$router.push("/");
          })
          .catch((e) => {
            this.showLoading = false;
            if (e && e.response && e.response.data && e.response.data.message)
              this.error = e.response.data.message;
            else
              this.error =
                "Something went wrong. Please check your details and try again later";
          });
      }
    },
    clear() {
      this.$refs.form.reset();
    },
    resetPassword() {
      this.showLoading = true;
      this.$store.state.axios
        .post("api/auth/ForgotPassword", { email: this.email })
        .then(() => {
          this.hasResetPassword = true;
        })
        .catch((e) => {
          if (e.response && e.response.status == 404)
            this.error =
              "That email address has not been registered for this service. Please check the spelling and try again";
          else if (e.response && e.response.data && e.response.data.message)
            this.error = e.response.data.message;
          else
            this.error =
              "Something went wrong. Please check your details and try again later";
        })
        .finally(() => (this.showLoading = false));
    },
  },
};
</script>
